export default {
    /**
     * Global States
     */
    datas:[],
    anotherState:{}
  }